// Small Result type for the client's internal error flow. It has the same
// { ok, value | error } shape as the server's RPC results. (neverthrow is not
// a client dependency; this keeps the client free of new installs.)

export type Result<T, E> = { ok: true; value: T } | { ok: false; error: E };

export function ok<T>(value: T): Result<T, never> {
  return { ok: true, value };
}

export function err<E>(error: E): Result<never, E> {
  return { ok: false, error };
}
